module.exports = __webpack_public_path__ + "static/img/metal.d1c30386.png";